import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Navigation from '../components/Navigation';
import { getComingSoonContent } from '../constants/comingSoonFeatures';
import './ComingSoonPage.css';

const ComingSoonPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const feature = searchParams.get('feature');
  const { title, description } = getComingSoonContent(feature);

  return (
    <div className="coming-soon-page">
      <Navigation />
      <main className="coming-soon-main">
        <div className="coming-soon-card">
          <span className="coming-soon-badge">Coming Soon</span>
          <h1 className="coming-soon-title">{title}</h1>
          <p className="coming-soon-description">{description}</p>
          <div className="coming-soon-actions">
            <Link to="/" className="coming-soon-primary">
              Back to Home
            </Link>
            <a href="mailto:support@worldasia.co.uk" className="coming-soon-secondary">
              Contact Support
            </a>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ComingSoonPage;
